import { DomainEntity, Id, Json } from "@homeleite/arch";
import { Address } from "../common";
import { ProducerSummary } from "../producers";
import { EMPTY } from "@homeleite/common-utils";

export class PropertySummary implements DomainEntity {
	constructor(
		public readonly id = Id.gen(),
		public name: string = EMPTY,
		public apcId: string = EMPTY,
        public producerId: string = EMPTY
	) { }

	toJson(): any {
		return Json.to.simple(this);
	}

	static fromJson(json: any): PropertySummary {
		return json ? Json.from.simple(json, PropertySummary) : null;
	}
}

export class Property implements DomainEntity {
	constructor(
		public readonly id = Id.gen(),
		public name: string = EMPTY,
		public apcId: string = EMPTY,
		public address: Address = null,
		public producer: ProducerSummary = new ProducerSummary(),
		public isDebtor = false,
		public readonly isActive = true,
	) { }

	toJson(): any {
		return Json.to.simple(this, {
			address: this.address ? this.address.toJson() : null,
			producer: this.producer ? this.producer.toJson() : null
		});
	}

	static fromJson(json: any): Property {
		return json ? Json.from.simple(json, Property, {
			address: json.address ? Address.fromJson(json.address) : null,
			producer: json.producer ? ProducerSummary.fromJson(json.producer) : null
		}) : null;
	}
}
